import api from "./API";

// OnePage = documento semanal (escopo workspace ou pessoal).
export const fetchOnePage = ({ scope, workspaceId, week }) =>
  api.get("/onepage", { params: { scope, workspaceId, week } });

export const persistOnePage = (payload) => api.put("/onepage", payload);
